import Links from './components/Links';

import { IconButton } from '@mui/material';
import { useSidebar } from 'hooks/UseSideBar';
import { BsArrowLeftCircleFill } from 'react-icons/bs';
import routes from 'routes.js';
import './sidebar.css';
const Sidebar = ({ open, onClose }) => {
  const { isCollapsed, toggleSidebar } = useSidebar();

  return (
    <div>
      <div
        className=" font-poppins  font-bold uppercase text-green-500 py-3 bg-green-50 "
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span onClick={toggleSidebar} className="cursor:pointer">
          {' '}
          <img src="/assets/img/logo.png" alt="logo-image" width={60} />
        </span>
        {!isCollapsed && (
          <span>
            FNTEC-<span class="font-small">MINEFOP</span>
          </span>
        )}
        {!isCollapsed && (
          <IconButton
            onClick={toggleSidebar}
            className="absolute right-[-5px] top-[-20px]"
            size="small"
            color="warning"
          >
            <BsArrowLeftCircleFill />
          </IconButton>
        )}
      </div>

      <hr />

      <ul
        className="mb-auto pt-1 mt-[10px] "
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Links routes={routes} />
      </ul>
    </div>
  );
};

export default Sidebar;
